<template lang="html">
    <v-tooltip bottom>
        <v-btn
            slot="activator"
            :disabled="!redistribute"
            class="my-3"
            block
            large
            @click="downloadCsv"
            color="primary">
            <v-icon left>mdi-table</v-icon>
            Download Data
        </v-btn>
        <span v-if="redistribute">Download CSV file</span>
        <span v-if="!redistribute">This station's data is not authorized for redistribution</span>
    </v-tooltip>
</template>

<script>
import axios from 'axios';
import fileDownload from 'js-file-download';

import * as actions from '@/constants/actions';

export default {
    props: {
        stationId: {
            default: '00',
        },
        redistribute: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    methods: {
        // download transferred csv data in the browser
        async downloadCsv() {
            try {
                const { data: file } = await axios.get(`${this.$cfg.API_URL}/stations/${this.stationId}.csv`, {
                    responseType: 'blob',
                });
                fileDownload(file, `station-data-${this.stationId}.csv`);
            } catch (e) {
                this.$store.dispatch(actions.TRIGGER_TOAST, 'This station\'s data is not authorized for redistribution');
            }
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/DownloadCsvButton.vue